import { Button, Collapse, message, Popover } from 'antd'
import styles from './index.module.scss'
import { useCallback, useContext, useRef, useMemo, useState, useEffect } from 'react'
import InputImageUploader from './components/InputImageUploader'
import ReferSelectionTrigger from './components/ReferSelectionTrigger'
import { AppContext } from '@utils/AppContext';
import GenerateMode from './components/GenerateMode'
import SkinRefine from './components/SkinRefine'
import Relight from './components/Relight'
import SegmentedWarp from './components/SegmentedWarp'
import CustomBkgMode from './components/CustomBkgMode'
import ReferSelectionDrawer from './components/ReferSelectionDrawer';
import PSAIModal from '@PSAIComponents/PSAIModal'
import { GenerateContext } from '../hooks/GenerateContext'
import { RESOURCE_TYPE, IMAGE_TYPE, PRIVATE_ABILITIES, RESOURCE_PARAMS, COMMODITY_SCENE_MODE, GENERATE_MODE, CLOTH_COLOR_TYPE, POSE_FANTASY_MODE, MODEL_EXPRESSION, MODEL_PROVIDER } from '@utils/CONST'
import ResolutionSelectionWrap from './components/ResolutionSelectionWrap'
import StrengthSlider from "./components/StrengthSlider"
import SelectGenerateResolution from "./components/SelectGenerateResolution"
import ColorSelection from "./components/ColorSelection"
import ColorPalette from './components/ColorPalette'
import UploadCustomMaterial from './components/UploadCustomMaterial'
import { workflowOfGenerate, generateDisabled } from '@utils/workflowOfBuildTaskV2'
import { RightOutlined, InfoCircleOutlined, LeftOutlined } from '@ant-design/icons';
import Utils from '@utils/utils';
import MattingOptGlasses from '@view/compoents/MattingOpt/MattingOptGlasses';
import MattingOptCommodityScene from '@view/compoents/MattingOpt/MattingOptCommodityScene';
import MattingOptSimTryon from '@view/compoents/MattingOpt/MattingOptSimTryon';
import API, { commonApiInvoker } from '@api/api';
import eventBus from '@utils/eventBus'
import ImgToVideoParams from './components/ImgToVideoParams'
import PosetryonPrompt from './components/PosetryonPrompt'
import Emoji from './components/Emoji'
import ModelHairstyle from './components/ModelHairstyle'
import ModelProvider from './components/ModelProvider'
import SmartDetailPlaceholder from './components/SmartDetailPlaceholder'
import GenerateActionBar from './components/GenerateActionBar'


const getSelectKey = (item) => item?.key || item?.id || item?.name
const removeExtension = (filename = '') => {
    if (filename === '.' || filename === '..') return filename
    const lastDot = filename.lastIndexOf('.')
    if (lastDot === -1 || lastDot === 0) return filename
    return filename.substring(0, lastDot)
}
const normalizeSmartDetailImageList = (list = [], seed = 'smartdetail') => {
    const safeList = (Array.isArray(list) ? list : []).filter(item => !!item?.url)
    const hasMain = safeList.some(item => item?.main)
    return safeList.map((item, index) => ({
        ...item,
        id: item?.id || `${seed}_${index}_${item?.url || 'image'}`,
        main: hasMain ? !!item?.main : index === 0,
    }))
}

const LeftComp = (props) => {
    const {
        hasPrivateAbility, setSelectedTaskListId,
        globalUser, globalOrgInfo
    } = useContext(AppContext);
    const generateContext = useContext(GenerateContext)
    const {
        taskInfo,
        setProjectId,
        imageType,

        tryonModelKeyList, setTryonModelKeyList,
        poseTryonKeyList, setPoseTryonKeyList,
        glassesTryonKeyList, setGlassesTryonKeyList,
        necklaceTryonKeyList, setNecklaceTryonKeyList,
        simTryonKeyList, setSimTryonKeyList,
        modelKeyList, setModelKeyList,
        sceneKeyList, setSceneKeyList,
        shoesKeyList, setShoesKeyList,
        videoKeyList, setVideoKeyList,
        colorKeyList, setColorKeyList,
        setRefImgConfig,

        generateNum, setGenerateNum,

        inputImageLoading, setInputImageLoading,
        topInputImageLoading, setTopInputImageLoading,
        bottomInputImageLoading, setBottomInputImageLoading,
        no1MultiAngleImageLoading, setNo1MultiAngleImageLoading,
        no2MultiAngleImageLoading, setNo2MultiAngleImageLoading,
        getMultiSemanticOutput,
        getSemanticSimTryonMaskId,
        getSemanticSimTryonMaskIdClothTypeAll,
        inputImageClothType,
        generateMode,
        modelProvider,
        clothColorKeyList, setClothColorKeyList,
        currentClothColorType, setCurrentClothColorType,
        currentPoseFantasyMode, setCurrentPoseFantasyMode,
        prompt, setPrompt,
        duration,
        prompts,
        emoji,
        setOutputRatio,
        setOutputWidth,
        setOutputHeight,
        setInputImageTransform
    } = generateContext
    const bottomRef = useRef()
    const isSmartDetailPage = imageType == IMAGE_TYPE.SMART_DETAILA_PAGE
    // 调色盘open
    const [colorPaletteOpen, setColorPaletteOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const [smartDetailImageList, setSmartDetailImageList] = useState([])
    const [smartDetailProductInfo, setSmartDetailProductInfo] = useState('')
    const [smartDetailMode, setSmartDetailMode] = useState('reference')
    const [smartDetailClarity, setSmartDetailClarity] = useState('2k')
    const [smartDetailRatio, setSmartDetailRatio] = useState('3:4')
    const [smartDetailPlatform, setSmartDetailPlatform] = useState('taobao')
    const [smartDetailLang, setSmartDetailLang] = useState('cn')
    const [smartDetailCustomItemList, setSmartDetailCustomItemList] = useState([])
    const [smartDetailConfirmOpen, setSmartDetailConfirmOpen] = useState(false)
    const [smartDetailNumLoading, setSmartDetailNumLoading] = useState(false)
    const [smartDetailConfirmType, setSmartDetailConfirmType] = useState('detail')
    const [smartDetailImageCount, setSmartDetailImageCount] = useState(0)
    const smartDetailInitProjectIdRef = useRef()
    const [flashModelUploaderBorder, setFlashModelUploaderBorder] = useState(false)
    const [flashModelRefBorder, setFlashModelRefBorder] = useState(false)
    const commodityImageInfoCacheRef = useRef(new Map())
    const emojiInitRef = useRef(true)
    // 抽屉默认选中的tab
    const [defaultActiveKey, setDefaultActiveKey] = useState()
    // 抽屉自定义上传禁用   
    const [customDisabled, setCustomDisabled] = useState(false)
    // 参考图类型
    const [resourceType, setResourceType] = useState(RESOURCE_TYPE.TRYON_MODEL)
    // 显示分辨率
    const showResolution = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITY
    }, [imageType])
    const showImgToVideoParams = useMemo(() => {
        return imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.MODEL_VIDEO
    }, [imageType])
    const smartDetailGenerateDisabled = useMemo(() => {
        if (!isSmartDetailPage) return false
        if (smartDetailMode === 'reference') return tryonModelKeyList.length === 0 || smartDetailImageList.length === 0 || !smartDetailProductInfo.trim()
        return smartDetailImageList.length === 0 || !smartDetailProductInfo.trim()
    }, [isSmartDetailPage, smartDetailMode, tryonModelKeyList, smartDetailImageList, smartDetailProductInfo])

    useEffect(() => {
        if (!isSmartDetailPage) return
        const taskProjectId = taskInfo?.projectId
        if (!taskProjectId || smartDetailInitProjectIdRef.current === taskProjectId) return
        smartDetailInitProjectIdRef.current = taskProjectId

        setSmartDetailImageList(normalizeSmartDetailImageList(taskInfo?.matchImages || [], taskProjectId))
        setSmartDetailProductInfo(taskInfo?.prompt || '')
        setSmartDetailMode(taskInfo?.smartDetailMode === 'reference' ? 'reference' : 'detail')
        setSmartDetailClarity(taskInfo?.smartDetailClarity || '2k')
        setSmartDetailRatio(taskInfo?.smartDetailRatio || '3:4')
        setSmartDetailPlatform(taskInfo?.smartDetailPlatform || 'taobao')
        setSmartDetailLang(taskInfo?.smartDetailLang || 'cn')
        setSmartDetailCustomItemList(taskInfo?.smartDetailCustomItemList || [])
    }, [isSmartDetailPage, taskInfo])

    useEffect(() => {
        const handleSmartDetailPlaceholderSelect = (payload) => {
            if (!isSmartDetailPage) return
            const imageUrl = payload?.url
            if (!imageUrl) return
            setSmartDetailImageList(normalizeSmartDetailImageList([{
                id: `placeholder_${Date.now()}`,
                url: imageUrl,
                name: payload?.name || '示例图',
                main: true,
            }], 'placeholder'))
        }
        eventBus.on('smartDetailPlaceholderSelectImage', handleSmartDetailPlaceholderSelect)
        return () => eventBus.off('smartDetailPlaceholderSelectImage', handleSmartDetailPlaceholderSelect)
    }, [isSmartDetailPage])
    const getMultiple = (type) => {
        if (isSmartDetailPage && type == RESOURCE_TYPE.TRYON_MODEL) return false
        if (type == RESOURCE_TYPE.TRYON_MODEL) return true
        if (type == RESOURCE_TYPE.POSE_TRYON) return true
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return false
        if (type == RESOURCE_TYPE.NECKLACE_TRYON) return true
        if (type == RESOURCE_TYPE.SIM_TRYON) return false
        if (type == RESOURCE_TYPE.MODEL) return false
        if (type == RESOURCE_TYPE.TRYON_SCENE && imageType == IMAGE_TYPE.GRASS_PLANT) return true
        if (type == RESOURCE_TYPE.TRYON_SHOES) return true
        if (type == RESOURCE_TYPE.COMMODITY_COLOR) return false
        if (type == RESOURCE_TYPE.CLOTH_RECOLOR) return false
        return false
    }
    // 抽屉是否多选
    const multiple = useMemo(() => {
        return getMultiple(resourceType)
    }, [resourceType])
    // 抽屉value
    const drawerValue = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.TRYON_MODEL) return tryonModelKeyList
        if (resourceType == RESOURCE_TYPE.POSE_TRYON) return poseTryonKeyList
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON) return glassesTryonKeyList
        if (resourceType == RESOURCE_TYPE.NECKLACE_TRYON) return necklaceTryonKeyList
        if (resourceType == RESOURCE_TYPE.SIM_TRYON) return simTryonKeyList
        if (resourceType == RESOURCE_TYPE.MODEL) return modelKeyList
        if (resourceType == RESOURCE_TYPE.TRYON_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.MODEL_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.TRYON_SHOES) return shoesKeyList
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) return videoKeyList
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) return sceneKeyList
        if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR) return colorKeyList
        if (resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) return clothColorKeyList
    }, [resourceType,
        tryonModelKeyList,
        poseTryonKeyList,
        modelKeyList,
        sceneKeyList,
        shoesKeyList,
        videoKeyList,
        colorKeyList,
        clothColorKeyList,
        glassesTryonKeyList,
        necklaceTryonKeyList,
        simTryonKeyList])
    // 抽屉change
    const getChangeFunc = (type) => {
        if (type == RESOURCE_TYPE.TRYON_MODEL) return setTryonModelKeyList
        if (type == RESOURCE_TYPE.POSE_TRYON) return setPoseTryonKeyList
        if (type == RESOURCE_TYPE.GLASSES_TRYON) return setGlassesTryonKeyList
        if (type == RESOURCE_TYPE.NECKLACE_TRYON) return setNecklaceTryonKeyList
        if (type == RESOURCE_TYPE.SIM_TRYON) return setSimTryonKeyList
        if (type == RESOURCE_TYPE.MODEL) return setModelKeyList
        if (type == RESOURCE_TYPE.TRYON_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.MODEL_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.TRYON_SHOES) return setShoesKeyList
        if (type == RESOURCE_TYPE.VIDEO_MODEL) return setVideoKeyList
        if (type == RESOURCE_TYPE.COMMODITY_SCENE) return setSceneKeyList
        if (type == RESOURCE_TYPE.COMMODITY_COLOR) return setColorKeyList
        if (type == RESOURCE_TYPE.CLOTH_RECOLOR) return setClothColorKeyList
    }
    const drawerOnChange = useCallback((value, refImgConfig) => {
        const onChange = getChangeFunc(resourceType)
        onChange?.(value)
        setRefImgConfig(refImgConfig)
    }, [resourceType])
    // 显示生成模式
    const showGenerateMode = useMemo(() => {
        return imageType == IMAGE_TYPE.CLOTHES ||
            imageType == IMAGE_TYPE.SHOES ||
            imageType == IMAGE_TYPE.GRASS_PLANT ||
            imageType == IMAGE_TYPE.GLASSES_TRYON ||
            imageType == IMAGE_TYPE.NECKLACE_TRYON ||
            imageType == IMAGE_TYPE.POSE_TRYON ||
            imageType == IMAGE_TYPE.COMMODITY ||
            imageType == IMAGE_TYPE.COMMODITYRECOLOR
    }, [imageType])
    // 显示人像皮肤优化
    const showSkinRefine = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL
    }, [imageType])
    // 显示光影融合
    const showRelight = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND
    }, [imageType])
    // 显示自定义背景模式
    const showCustomBkgMode = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL &&
            sceneKeyList.find(item => item.custom)
    }, [imageType, sceneKeyList])
    // 显示输出图分辨率选择
    const showGenerateResolution = useMemo(() => {
        return (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) && sceneKeyList.length > 0
    }, [imageType, sceneKeyList])
    // 显示相似度滑块
    const showStrengthSlider = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITY && sceneKeyList.find(item => item.custom)
    }, [imageType, sceneKeyList])
    const showColorSelection = useMemo(() => {
        return imageType == IMAGE_TYPE.COMMODITYRECOLOR
    }, [imageType])
    // 显示服饰换色颜色选择
    const showClothColorSelection = useMemo(() => {
        return imageType == IMAGE_TYPE.CLOTH_RECOLOR
    }, [imageType])
    const showNumSelect = useMemo(() => {
        return imageType != IMAGE_TYPE.MODEL_VIDEO && imageType != IMAGE_TYPE.IMAGE_TO_VIDEO
    }, [imageType])
    // 显示表情
    const showEmoji = useMemo(() => {
        return imageType == IMAGE_TYPE.MODEL
    }, [imageType])
    // 显示模特发型
    const showModelHairstyle = useMemo(() => {
        // return imageType == IMAGE_TYPE.MODEL
        return false
    }, [imageType])
    // 删除参考图
    const handleRemove = (resourceType) => {
        PSAIModal.confirm({
            title: `确定删除所选${resourceType == RESOURCE_TYPE.VIDEO_MODEL ? '参考视频' : '参考图'}？`,
            onOk() {
                const onChange = getChangeFunc(resourceType)
                onChange?.([])
            },
            onCancel() { },
        })
    }

    // 保存素材mask
    const saveMaterialPreference = (mask, item, semanticSimTryonMaskId, semanticSimTryonMaskId2) => {
        if (!RESOURCE_PARAMS[resourceType]) return
        const params = { ...RESOURCE_PARAMS[resourceType] }
        commonApiInvoker(API.saveMaterialPreference({
            ...params,
            attr: {
                refMask: mask.binaryMask,
                foregroundAlphaMask: mask.foregroundAlphaMask,
                foregroundMask: mask.foregroundMask,
                semanticSimTryonMaskId,
                semanticSimTryonMaskId2,
            },
            key: item?.key,
            custom: !!item?.custom,
        })).then(res => {
            console.log('saveMaterialPreference')
            // 更新素材列表
            eventBus.emit('updateCustomMaterial')
            // 更新已选中的glassesTryonKeyList
            const setUpdateList = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? setGlassesTryonKeyList :
                resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? setNecklaceTryonKeyList :
                resourceType == RESOURCE_TYPE.SIM_TRYON ? setSimTryonKeyList :
                    resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? setSceneKeyList : null
            setUpdateList && setUpdateList(prevList => {
                const updatedList = prevList.map(prevItem => {
                    if (prevItem.key === item.key) {
                        return {
                            ...prevItem,
                            attr: {
                                ...prevItem.attr,
                                refMask: mask.binaryMask,
                                foregroundAlphaMask: mask.foregroundAlphaMask,
                                foregroundMask: mask.foregroundMask,
                                mattingRect: mask.mattingRect,
                            }
                        };
                    }
                    return prevItem;
                });
                return updatedList;
            });
        })
    }
    // 打开眼镜/同版型mask弹窗
    const onGlassesMattingOpt = async (item, semanticMaskId = null, semanticMaskId2 = null, isEdit = false) => {
        let binaryMask, foregroundAlphaMask, foregroundMask, inputImage, mattingRect
        inputImage = item?.url || ''
        binaryMask = item?.attr?.refMask || ''
        foregroundAlphaMask = item?.attr?.foregroundAlphaMask || ''
        foregroundMask = item?.attr?.foregroundMask || ''
        mattingRect = item?.attr?.mattingRect || null
        // 发起抠图优化
        handleMattingOpt(0, [{
            inputImage,
            binaryMask,
            foregroundAlphaMask,
            foregroundMask,
            mattingRect,
            semanticMaskId,
            semanticMaskId2,
        }], resList => {
            const res = resList[0]
            if (!res) return
            saveMaterialPreference(res, item, semanticMaskId, semanticMaskId2)
        }, isEdit)
    }
    // 编辑素材mask
    const handleEditMask = async () => {
        const item = resourceType == RESOURCE_TYPE.GLASSES_TRYON ? glassesTryonKeyList[0] :
            resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? necklaceTryonKeyList[0] :
            resourceType == RESOURCE_TYPE.SIM_TRYON ? simTryonKeyList[0] :
                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? sceneKeyList[0] :
                    null
        console.log('item?--------------', item)
        if (!item) return
        if (resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.NECKLACE_TRYON || resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            await onGlassesMattingOpt(item, null, null, true)
        } else if (resourceType == RESOURCE_TYPE.SIM_TRYON) {
            const semanticSimTryonMaskId = item?.attr?.semanticSimTryonMaskId
            const semanticSimTryonMaskId2 = item?.attr?.semanticSimTryonMaskId2 // 全label分割结果
            if (semanticSimTryonMaskId) {
                await onGlassesMattingOpt(item, semanticSimTryonMaskId, semanticSimTryonMaskId2, true)
                return
            } else {
                const res = await getSemanticSimTryonMaskId(item?.url)
                const ids = res.split(":")
                const semanticMaskId = ids[1]

                const res2 = await getSemanticSimTryonMaskIdClothTypeAll(item?.imageUrl)
                const ids2 = res2.split(":")
                const semanticMaskId2 = ids2[1]
                await onGlassesMattingOpt(item, semanticMaskId, semanticMaskId2, true)
            }
        }
    }

    const formatSelectedMaterialItem = (item) => {
        return {
            key: getSelectKey(item),
            attr: item?.attr || {},
            title: item?.attr?.title || item?.name || '',
            url: item?.imageUrlWithVersion || item?.imageUrl,
            custom: item?.isCustom ? 1 : 0,
        }
    }

    const getRefImgConfigByItem = (item, resourceType, custom) => {
        if (resourceType != RESOURCE_TYPE.COMMODITY_SCENE || !custom) return null
        return {
            refImg: item.imageUrlWithVersion,
            refImgMask: item?.attr?.mask || null,
            refImgProcessed: item?.attr?.imgProcessed || null,
            refImgSize: {
                width: item?.attr?.width,
                height: item?.attr?.height
            },
            refImgLocalInfo: item?.attr?.objectLocationInfo || null,
            refImgPrompt: item?.attr?.prompt,
            refImgMode: item?.attr?.version == 3 ? COMMODITY_SCENE_MODE.SAME_STYLE : COMMODITY_SCENE_MODE.SIMILAR_STYLE,
        }
    }

    const removeOssProcessFromUrl = useCallback((url) => {
        if (!url) return url
        try {
            const urlObj = new URL(url)
            urlObj.searchParams.delete('x-oss-process')
            return urlObj.toString()
        } catch (e) {
            return url.replace(/([?&])x-oss-process=[^&]*/g, '$1').replace(/[?&]$/, '')
        }
    }, [])

    const getImageSizeByOssInfo = useCallback(async (url) => {
        if (!url) return {}
        const originUrl = removeOssProcessFromUrl(url)
        if (commodityImageInfoCacheRef.current.has(originUrl)) {
            return commodityImageInfoCacheRef.current.get(originUrl)
        }
        const infoUrl = Utils.addParamsToUrl(originUrl, { "x-oss-process": "image/quality,q_10/format,webp/info" })
        try {
            const res = await fetch(infoUrl)
            const text = await res.text()
            const info = JSON.parse(text || '{}')
            const parseNum = (raw) => {
                if (raw == null) return undefined
                if (typeof raw === 'object') return Number(raw?.value) || undefined
                return Number(raw) || undefined
            }
            const next = {
                width: parseNum(info?.ImageWidth) || parseNum(info?.imageWidth) || parseNum(info?.width),
                height: parseNum(info?.ImageHeight) || parseNum(info?.imageHeight) || parseNum(info?.height),
                originUrl,
            }
            commodityImageInfoCacheRef.current.set(originUrl, next)
            return next
        } catch (e) {
            return { originUrl }
        }
    }, [removeOssProcessFromUrl])

    const appendUploadedSelection = async (item, resourceType) => {
        const onChange = getChangeFunc(resourceType)
        if (!onChange || !item) return
        const multiple = getMultiple(resourceType)
        const isGrassPlantTryonScene = resourceType == RESOURCE_TYPE.TRYON_SCENE && imageType == IMAGE_TYPE.GRASS_PLANT
        const maxCount = isGrassPlantTryonScene ? 4 : 5
        const selectedItem = formatSelectedMaterialItem(item)
        // 上传后默认选中统一按“自定义素材”处理
        selectedItem.custom = 1
        selectedItem.attr = {
            ...(selectedItem?.attr || {}),
            custom: true,
        }
        let refImgConfig = getRefImgConfigByItem(item, resourceType, true)
        const updateSelection = (prev) => {
            const temp = [...prev]
            if (temp.find(i => i.key == selectedItem.key)) return prev
            if (multiple) {
                temp.push(selectedItem)
                return temp.slice(-maxCount)
            }
            return [selectedItem]
        }
        // 商品背景默认同步输出分辨率
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) {
            const imageUrl = selectedItem?.url || item?.imageUrlWithVersion || item?.imageUrl
            const sizeInfo = await getImageSizeByOssInfo(imageUrl)
            const width = sizeInfo?.width || item?.attr?.width
            const height = sizeInfo?.height || item?.attr?.height
            selectedItem.attr = {
                ...(selectedItem?.attr || {}),
                width,
                height,
                originUrl: sizeInfo?.originUrl || imageUrl,
                refCropUrl: selectedItem?.attr?.refImage || imageUrl,
            }
            if (refImgConfig) {
                refImgConfig = {
                    ...refImgConfig,
                    refImgSize: { width, height }
                }
            }
            setOutputRatio('custom')
            setOutputWidth(width)
            setOutputHeight(height)
            setInputImageTransform()
        }
        onChange(updateSelection)
        refImgConfig && setRefImgConfig(refImgConfig)
    }

    const optFactory = (resourceType, imageType) => {
        const value = resourceType == RESOURCE_TYPE.TRYON_MODEL ? tryonModelKeyList :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? poseTryonKeyList :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? glassesTryonKeyList :
                    resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? necklaceTryonKeyList :
                    resourceType == RESOURCE_TYPE.SIM_TRYON ? simTryonKeyList :
                        resourceType == RESOURCE_TYPE.MODEL ? modelKeyList :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? sceneKeyList :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? sceneKeyList :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? shoesKeyList :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? videoKeyList :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? sceneKeyList :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? colorKeyList :
                                                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? clothColorKeyList :
                                                        []
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "选择参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "选择参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "选择参考图" :
                    resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? "选择参考图" :
                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "选择颜色" :
                        resourceType == RESOURCE_TYPE.SIM_TRYON ? "选择参考图" :
                            resourceType == RESOURCE_TYPE.MODEL ? "选择模特" :
                                resourceType == RESOURCE_TYPE.MODEL_SCENE ? "选择背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SCENE ? "选择背景" :
                                        resourceType == RESOURCE_TYPE.TRYON_SHOES ? "选择参考图" :
                                            resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "选择视频" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "选择参考图" :
                                                    resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "选择颜色" :
                                                        ""
        const triggerUploadText = resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "点击/拖拽上传" :
            (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.MODEL) ? "点击上传" :
                (imageType == IMAGE_TYPE.CLOTHES && resourceType == RESOURCE_TYPE.TRYON_SCENE) ? "点击/拖拽上传" :
                    resourceType == RESOURCE_TYPE.MODEL ? "点击上传" :
                        "点击/拖拽上传"

        const dragTips = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "释放鼠标上传参考图" :
            resourceType == RESOURCE_TYPE.POSE_TRYON ? "释放鼠标上传参考图" :
                resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "释放鼠标上传参考图" :
                    resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? "释放鼠标上传参考图" :
                    resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "释放鼠标上传颜色" :
                        resourceType == RESOURCE_TYPE.SIM_TRYON ? "释放鼠标上传参考图" :
                            resourceType == RESOURCE_TYPE.MODEL ? "释放鼠标上传模特" :
                                resourceType == RESOURCE_TYPE.MODEL_SCENE ? "释放鼠标上传背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SCENE ? "释放鼠标上传背景" :
                                        resourceType == RESOURCE_TYPE.TRYON_SHOES ? "释放鼠标上传参考图" :
                                            resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "释放鼠标上传动作" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "释放鼠标上传背景" :
                                                    resourceType == RESOURCE_TYPE.COMMODITY_COLOR ? "释放鼠标上传颜色" :
                                                        ""
        // const customDisabled = (resourceType == RESOURCE_TYPE.VIDEO_MODEL && !hasPrivateAbility(PRIVATE_ABILITIES.VIDEO_TRYON_DIY_KEY))
        const customDisabled = false
        // const vipOnly = resourceType == RESOURCE_TYPE.VIDEO_MODEL 
        // 上传多个
        const uploadMultiple = resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? false :
            true
        return {
            key: resourceType,
            resourceType,
            multiple: getMultiple(resourceType),
            uploadMultiple,
            value,
            // vipOnly, 、// vip图标
            triggerText,
            triggerUploadText,
            dragTips,
            customDisabled,
            onClick: key => {
                handelOpenDrawer(key, resourceType, customDisabled)
            },
            onSecondaryClick: key => {
                if (resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR) {
                    setColorPaletteOpen(true)
                } else {
                    handelOpenDrawer(key, resourceType, customDisabled)
                }
            },
            onUpload: (file, uploadOptions) => handleTriggerUpload(file, resourceType, resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? COMMODITY_SCENE_MODE.SIMILAR_STYLE : null, uploadOptions), // 第三个参数固定写死成原相似风格，可移除
            onRemove: () => handleRemove(resourceType),
            onEditMask: () => handleEditMask()
        }
    }

    // 选择器
    const items = imageType == IMAGE_TYPE.CLOTHES ?
        [{
            key: RESOURCE_TYPE.TRYON_MODEL,
            label: <div>试衣参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
            children: <>
                <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_MODEL, imageType)} />
                <ModelProvider />
            </>,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.TRYON_MODEL, imageType)?.value?.length > 0,
        },
        ...(modelProvider == MODEL_PROVIDER.SOTA ? [] : [{
            key: RESOURCE_TYPE.MODEL,
            label: <div>模特<span style={{ color: "var(--gray-middgray)" }}>（非必选）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL, imageType)} />,
            showArrow: true,
            defaultActive: optFactory(RESOURCE_TYPE.MODEL, imageType)?.value?.length > 0,
        }, {
            key: RESOURCE_TYPE.TRYON_SCENE,
            label: <div>背景<span style={{ color: "var(--gray-middgray)" }}>（非必选）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_SCENE, imageType)} />,
            showArrow: true,
            defaultActive: optFactory(RESOURCE_TYPE.TRYON_SCENE, imageType)?.value?.length > 0,
        }])] : imageType == IMAGE_TYPE.POSE_TRYON ? (
            currentPoseFantasyMode == POSE_FANTASY_MODE.REFERENCEMODE ? [{
                key: RESOURCE_TYPE.POSE_TRYON,
                label: <div>姿势参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.POSE_TRYON, imageType)} />,
                showArrow: false,
                defaultActive: optFactory(RESOURCE_TYPE.POSE_TRYON, imageType)?.value?.length > 0,
            }] : [{
                key: RESOURCE_TYPE.POSE_TRYON,
                label: <div className={styles.Title}>
                    <div>姿势描述</div>
                    <p className={styles.Template}
                        onClick={open ? () => setOpen(false) : () => handelOpenDrawer("prompt", RESOURCE_TYPE.POSTRYON_PROMPT)}
                    >描述模版 {open ? <LeftOutlined /> : <RightOutlined />}</p>
                </div>,
                children: <PosetryonPrompt />,
                showArrow: false,
            }]
        ) : imageType == IMAGE_TYPE.GLASSES_TRYON ? [{
            key: RESOURCE_TYPE.GLASSES_TRYON,
            label: <div>试戴参考图</div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.GLASSES_TRYON, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.GLASSES_TRYON, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.NECKLACE_TRYON ? [{
            key: RESOURCE_TYPE.NECKLACE_TRYON,
            label: <div>试戴参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.NECKLACE_TRYON, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.NECKLACE_TRYON, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.SIM_TRYON ? [{
            key: RESOURCE_TYPE.SIM_TRYON,
            label: <div>同版型参考图</div>,
            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.SIM_TRYON, imageType)} />,
            showArrow: false,
            defaultActive: optFactory(RESOURCE_TYPE.SIM_TRYON, imageType)?.value?.length > 0,
        }] : imageType == IMAGE_TYPE.MODEL ?
            [{
                key: RESOURCE_TYPE.MODEL,
                label: "模特参考图",
                children: (
                    <div className={flashModelRefBorder ? styles.FlashBorder : ''}>
                        <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL, imageType)} />
                    </div>
                ),
                showArrow: true,
                defaultActive: true,
            }, {
                key: RESOURCE_TYPE.MODEL_SCENE,
                label: <div>背景<span style={{ color: "var(--gray-middgray)" }}>（非必选）</span></div>,
                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL_SCENE, imageType)} />,
                showArrow: true,
                defaultActive: sceneKeyList.length > 0,
            }] :
            imageType == IMAGE_TYPE.BACKGROUND ?
                [{
                    key: RESOURCE_TYPE.MODEL_SCENE,
                    label: <div>背景</div>,
                    children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL_SCENE, imageType)} />,
                    showArrow: true,
                    defaultActive: true,
                }] :
                imageType == IMAGE_TYPE.SHOES ?
                    [{
                        key: RESOURCE_TYPE.TRYON_SHOES,
                        label: <div>试鞋参考图<span style={{ color: "var(--gray-middgray)" }}>（1-5张）</span></div>,
                        children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_SHOES, imageType)} />,
                        showArrow: false,
                        defaultActive: optFactory(RESOURCE_TYPE.TRYON_SHOES, imageType)?.value?.length > 0,
                    }] :
                    imageType == IMAGE_TYPE.MODEL_VIDEO ?
                        [{
                            key: RESOURCE_TYPE.VIDEO_MODEL,
                            label: "参考视频",
                            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.VIDEO_MODEL, imageType)} />,
                            showArrow: false,
                            defaultActive: optFactory(RESOURCE_TYPE.VIDEO_MODEL, imageType)?.value?.length > 0,
                        }] :
                        imageType == IMAGE_TYPE.COMMODITY ?
                            [{
                                key: RESOURCE_TYPE.COMMODITY_SCENE,
                                label: <p>背景参考图</p>,
                                children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.COMMODITY_SCENE, imageType)} />,
                                showArrow: false,
                                defaultActive: optFactory(RESOURCE_TYPE.COMMODITY_SCENE, imageType)?.value?.length > 0,
                            }] :
                            imageType == IMAGE_TYPE.COMMODITYRECOLOR ?
                                [{
                                    key: RESOURCE_TYPE.COMMODITY_COLOR,
                                    label: "目标颜色",
                                    children: (
                                        <ColorPalette
                                            value={colorKeyList[0]}
                                            onChange={color => setColorKeyList([color])}
                                            open={colorPaletteOpen}
                                            onOpenChange={setColorPaletteOpen}
                                        >
                                            <div>
                                                <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.COMMODITY_COLOR, imageType)} />
                                            </div>
                                        </ColorPalette>
                                    ),
                                    showArrow: false,
                                }] : imageType == IMAGE_TYPE.CLOTH_RECOLOR ?
                                    [{
                                        key: RESOURCE_TYPE.CLOTH_RECOLOR,
                                        label: "目标颜色",
                                        children: (
                                            <ColorPalette
                                                value={clothColorKeyList[0]}
                                                onChange={color => setClothColorKeyList([color])}
                                                open={colorPaletteOpen}
                                                onOpenChange={setColorPaletteOpen}
                                            >
                                                <div>
                                                    <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.CLOTH_RECOLOR, imageType)} />
                                                </div>
                                            </ColorPalette>
                                        ),
                                        showArrow: false,
                                    }] : imageType == IMAGE_TYPE.GRASS_PLANT ?
                                        [{
                                            key: RESOURCE_TYPE.MODEL,
                                            label: <div>网红<span style={{ color: "var(--gray-middgray)" }}>（非必选）</span></div>,
                                            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.MODEL, imageType)} />,
                                            showArrow: true,
                                            defaultActive: true,
                                        }, {
                                            key: RESOURCE_TYPE.TRYON_SCENE,
                                            label: <div>背景氛围图<span style={{ color: "var(--gray-middgray)" }}>（非必选）</span></div>,
                                            children: <ReferSelectionTrigger {...optFactory(RESOURCE_TYPE.TRYON_SCENE, imageType)} />,
                                            showArrow: true,
                                            defaultActive: true,
                                        }]
                                        : []
    // 选中的collapse
    const [value, setValue] = useState(items.filter(item => !item.showArrow || item.defaultActive).map(item => item.key));
    // 切换collapse
    const handleCollapseChange = (value) => {
        // 包含所有元素且不重复
        const containsAllElementsWithoutDuplicates = (A, B) => {
            const setA = new Set(A);
            return B.every(item => setA.has(item));
        }
        const notCollapseKeys = items.filter(item => !item.showArrow).map(item => item.key)
        if (containsAllElementsWithoutDuplicates(value, notCollapseKeys)) {
            setValue(value);
        } else {
            setValue([...notCollapseKeys, ...value])
        }
    };
    // 打开抽屉
    const handelOpenDrawer = (defaultActiveKey, resourceType, customDisabled = false) => {
        console.log('defaultActiveKey', defaultActiveKey)
        setOpen(true)
        setResourceType(resourceType)
        setDefaultActiveKey(defaultActiveKey)
        setCustomDisabled(customDisabled)
    }

    // 兼容眼镜试戴、同版型试衣时，直接赋值resourceType，便于保存涂抹素材mask后判断逻辑
    useEffect(() => {
        if (imageType != IMAGE_TYPE.GLASSES_TRYON && imageType != IMAGE_TYPE.NECKLACE_TRYON && imageType != IMAGE_TYPE.SIM_TRYON) return
        if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            setResourceType(RESOURCE_TYPE.NECKLACE_TRYON)
            return
        }
        setResourceType(imageType)
    }, [imageType])


    // 生成
    const [loading, setLoading] = useState(false)
    const smartDetailReferenceItem = tryonModelKeyList?.[0]
    const smartDetailUnitPrice = smartDetailClarity === '4k' ? 120 : 80
    const smartDetailPresetDetailPageNum = Number(smartDetailReferenceItem?.attr?.detailPageNum) || 0
    const smartDetailReferenceCount = smartDetailMode === 'reference'
        ? (smartDetailPresetDetailPageNum > 0 ? smartDetailPresetDetailPageNum : smartDetailImageCount)
        : smartDetailImageCount
    const smartDetailCountKeys = useMemo(() => ([
        'poster',
        'sellingPoint',
        'buyerShow',
        'sceneStyling',
        'productInfo',
        'productDetail',
        'sizeChart',
        'serviceGuarantee',
    ]), [])
    const smartDetailCustomCount = useMemo(() => {
        return smartDetailCustomItemList.reduce((sum, item) => {
            if (!smartDetailCountKeys.includes(item?.key)) return sum
            if (item?.checked === false) return sum
            return sum + (Number(item?.value) || 0)
        }, 0)
    }, [smartDetailCustomItemList, smartDetailCountKeys])
    const smartDetailCostBean = smartDetailMode === 'detail'
        ? smartDetailCustomCount * smartDetailUnitPrice
        : smartDetailReferenceCount * smartDetailUnitPrice
    const smartDetailConfirmCostBean = smartDetailImageCount * smartDetailUnitPrice

    const getSmartDetailNum = (data) => {
        if (typeof data === 'number') return data
        if (Array.isArray(data)) return Number(data?.[0]?.pre_count ?? data?.[0]?.num ?? data?.[0]?.count ?? data?.[0]?.imageNum ?? data.length) || 0
        if (data && typeof data === 'object') return Number(data.num ?? data.count ?? data.imageNum ?? data.total) || 0
        return 0
    }
    const ensureGenerateAccess = (callback) => {
        const status = Utils.checkLoginStatus(callback)
        if (!status) return false

        if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.MODEL_VIDEO) {
            const isPaidUser = globalUser?.membership?.level !== 0
            if (!isPaidUser) {
                message.warning('视频生成需要付费用户或者企业版用户')
                eventBus.emit('recharge')
                return false
            }
        }
        if (isSmartDetailPage) {
            const isPaidUser = globalUser?.membership?.level !== 0
            if (!isPaidUser) {
                message.warning('该功能为会员用户专属,请充值会员后使用')
                eventBus.emit('recharge')
                return false
            }
        }
        if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            const isPaidUser = globalUser?.membership?.level !== 0
            if (!isPaidUser) {
                message.warning('该功能为会员用户专属,请充值会员后使用')
                eventBus.emit('recharge')
                return false
            }
        }
        if (imageType == IMAGE_TYPE.CLOTHES && modelProvider == MODEL_PROVIDER.SOTA) {
            const isPaidUser = globalUser?.membership?.level !== 0
            if (!isPaidUser) {
                message.warning('该功能为会员用户专属,请充值会员后使用')
                eventBus.emit('recharge')
                return false
            }
        }

        return true
    }

    const openSmartDetailConfirm = async () => {
        if (smartDetailMode === 'detail') {
            setSmartDetailConfirmType('detail')
            setSmartDetailImageCount(smartDetailCustomCount)
            setSmartDetailConfirmOpen(true)
            setSmartDetailNumLoading(false)
            return
        }

        if (smartDetailPresetDetailPageNum > 0) {
            setSmartDetailConfirmType('preset')
            setSmartDetailImageCount(smartDetailPresetDetailPageNum)
            setSmartDetailConfirmOpen(true)
            setSmartDetailNumLoading(false)
            return
        }

        const key = smartDetailReferenceItem?.key
        if (!key) {
            message.warning('请先选择参考图')
            return
        }
        setSmartDetailImageCount(0)
        setSmartDetailConfirmType('analyzed')
        setSmartDetailConfirmOpen(true)
        setSmartDetailNumLoading(true)
        try {
            const res = await API.doDetailPageNum({
                key,
                custom: smartDetailReferenceItem?.custom ? 1 : 0,
            })
            if (res?.code !== 0) throw new Error(res?.message || '参考图分析失败')
            const imageCount = getSmartDetailNum(res?.data) || getSmartDetailNum(res?.attr)
            if (!imageCount) throw new Error('参考图分析结果为空')
            setSmartDetailImageCount(imageCount)
            if (smartDetailReferenceItem?.custom && smartDetailReferenceItem?.key) {
                try {
                    const imageUrl = smartDetailReferenceItem?.url || smartDetailReferenceItem?.imageUrl || ''
                    if (!imageUrl) throw new Error('参考图缺少url')
                    const saveRes = await API.saveCustomMaterialv2({
                        id: smartDetailReferenceItem.key,
                        image: imageUrl,
                        attr: { detailPageNum: imageCount },
                    })
                    if (saveRes?.code === 0) {
                        setTryonModelKeyList(prev => prev.map((item) => (
                            item?.key === smartDetailReferenceItem.key
                                ? { ...item, attr: { ...(item?.attr || {}), detailPageNum: imageCount } }
                                : item
                        )))
                        eventBus.emit('updateCustomMaterial')
                    }
                } catch (e) { }
            }
        } catch (err) {
            message.warning(err?.message || '参考图分析失败')
            setSmartDetailConfirmOpen(false)
        } finally {
            setSmartDetailNumLoading(false)
        }
    }

    const handleSmartDetailContinue = async () => {
        if (!ensureGenerateAccess(() => handleSmartDetailContinue())) return
        await openSmartDetailConfirm()
    }

    const handleGenerate = async () => {
        try {
            if (!ensureGenerateAccess(() => handleGenerate())) return

            setLoading(true)
            // 关闭抽屉
            setOpen(false)
            // 检查生成参数是否齐全
            if ((isSmartDetailPage ? smartDetailGenerateDisabled : generateDisabled(imageType, generateContext)) || isLoading) return
            const workflowExtra = isSmartDetailPage ? {} : {
                projectId: generateContext.projectId
            }
            const projectId = await workflowOfGenerate(imageType, {
                ...generateContext,
                smartDetailMode,
                smartDetailImageList,
                smartDetailProductInfo,
                smartDetailCustomItemList,
                smartDetailClarity,
                smartDetailRatio,
                smartDetailPlatform,
                smartDetailLang,
                smartDetailDetailPageNum: smartDetailMode === 'reference' ? smartDetailReferenceCount : smartDetailCustomCount,
            }, workflowExtra)
            if (!projectId) return
            setSelectedTaskListId(projectId)
            setProjectId(projectId)
            message.success("生成中，请稍等片刻")
            props.createClick()
        } catch (err) {
            console.log(err)
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    // 上传自定义素材
    const uploadCustomMaterialRef = useRef()
    const handleUpload = (...args) => {
        return uploadCustomMaterialRef.current?.doUpload(...args)
    }
    const handleTriggerUpload = async (file, resourceType, commoditySceneMode, uploadOptions) => {
        // 视频仍保留原上传链路
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            return handleUpload(file, resourceType, commoditySceneMode, uploadOptions)
        }
        if (!(file instanceof File)) {
            file = await Utils.urlToFile(file)
        }
        const isNormal = await Utils.validateImageFile(file, true)
        if (!isNormal) return false
        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
        if (!resizeRes || !resizeRes.success) throw new Error(resizeRes?.message || '图片处理失败')
        const legalRes = await Utils.checkImageIslegal(resizeRes.file, 1, null, true)
        if (!legalRes) return false
        if (!legalRes.isLegal) {
            PSAIModal.confirm({
                content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                okText: '知道了',
                cancelText: '取消',
                onOk() { },
                onCancel() { },
            })
            return false
        }
        const imageUrl = legalRes.data
        const name = removeExtension(file?.name || '自定义素材')
        const saveRes = await commonApiInvoker(API.materialResBatchSave({
            items: [{
                imageUrl,
                name,
                folderId: '',
                scope: 'personal',
                attr: {},
            }]
        }))
        if (!saveRes) return false
        const params = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const listRes = await commonApiInvoker(API.materialList({
            scope: 'personal',
            folderId: '',
            keyword: '',
            pageIndex: 1,
            pageSize: 2000,
            withAttr: true,
            func: params.func,
            type: params.type,
        }))
        const images = listRes?.images?.items || []
        const uploadedItem = images.find(item => item?.imageUrl === imageUrl || item?.name === name)
        const shouldAutoSelectUploaded = resourceType != RESOURCE_TYPE.GLASSES_TRYON &&
            resourceType != RESOURCE_TYPE.SIM_TRYON
        if (uploadedItem && shouldAutoSelectUploaded) {
            await appendUploadedSelection(uploadedItem, resourceType)
        } else if (!shouldAutoSelectUploaded) {
            // 眼镜试戴/项链试戴/同版型试衣：上传后仅打开抽屉并定位到个人参考图，不自动选中
            handelOpenDrawer('custom', resourceType)
        }
        eventBus.emit('updateCustomMaterial')
        return uploadedItem || saveRes
    }
    // 选择张数
    const selectedNum = useMemo(() => {
        let num = 1
        if (imageType == IMAGE_TYPE.CLOTHES) {
            num = tryonModelKeyList.length
        } else if (imageType == IMAGE_TYPE.SHOES) {
            num = shoesKeyList.length
        } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            num = necklaceTryonKeyList.length
        } else if (imageType == IMAGE_TYPE.POSE_TRYON) {
            if (currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
                num = prompts.filter(item => item).length
            } else {
                num = poseTryonKeyList.length
            }
        } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
            num = sceneKeyList.length
        }
        return Math.max(num, 1)
    }, [imageType, tryonModelKeyList, shoesKeyList, necklaceTryonKeyList, poseTryonKeyList, currentPoseFantasyMode, prompts, sceneKeyList])
    // 虹豆消耗：衣服图10/张；其他10/张；视频80
    const costBean = useMemo(() => {
        // console.log('imageType', imageType)
        let unitPrice = generateMode == GENERATE_MODE.STD ? 10 : 15
        let totalNum = generateNum * selectedNum
        if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            unitPrice = generateMode == GENERATE_MODE.STD ? 80 : 120
        }
        if (imageType == IMAGE_TYPE.CLOTHES && modelProvider == MODEL_PROVIDER.SOTA) {
            unitPrice = generateMode == GENERATE_MODE.STD ? 80 : 120
        }
        if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            unitPrice = (Math.round(videoKeyList?.[0]?.attr?.duration / 1000) || 0) * (generateMode == GENERATE_MODE.STD ? 25 : 40)
        }
        if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            unitPrice = generateMode == GENERATE_MODE.STD ? (duration == 5 ? 110 : 220) : (duration == 5 ? 200 : 400)
        }
        return totalNum * unitPrice
    }, [imageType, selectedNum, generateNum, generateMode, duration, videoKeyList, modelProvider])
    // 展开箭头方向
    const expandIcon = (props) => {
        return <RightOutlined rotate={props.isActive ? -90 : 90} />
    }
    // 生成数量显示
    // 能多选参考图的，默认状态下显示4张，选择1张后再显示*1
    const labelRender = props => {
        let num = 1
        let showNum = false
        if (imageType == IMAGE_TYPE.CLOTHES) {
            num = tryonModelKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.SHOES) {
            num = shoesKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            num = necklaceTryonKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.REFERENCEMODE) {
            num = poseTryonKeyList.length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
            num = prompts.filter(item => item).length
            if (!num) showNum = false
            else showNum = true
        } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
            num = sceneKeyList.length
            if (!num) showNum = false
            else showNum = true
        }
        return showNum ? `${props.label} * ${selectedNum}` : props.label
    }

    const isLoading = useMemo(() => {
        return inputImageLoading ||
            topInputImageLoading ||
            bottomInputImageLoading ||
            no1MultiAngleImageLoading ||
            no2MultiAngleImageLoading
    }, [
        inputImageLoading,
        topInputImageLoading,
        bottomInputImageLoading,
        no1MultiAngleImageLoading,
        no2MultiAngleImageLoading,
    ])

    // 素材涂抹弹窗
    const [mattingOptOpen, setMattingOptOpen] = useState(false)
    const [mattingOptGroups, setMattingOptGroups] = useState([])
    const [mattingOptIndex, setMattingOptIndex] = useState(0)
    const [mattingOptLoading, setMattingOptLoading] = useState(false)
    const [mattingOptIsEdit, setMattingOptIsEdit] = useState(false)
    const mattingOptRefs = useRef([])
    const mattingOptCallback = useRef(null)

    const handleMattingOpt = (current, groups, callback, isEdit = false) => {
        console.log('groups', groups)
        setMattingOptOpen(true)
        setMattingOptGroups(groups)
        setMattingOptIndex(current)
        setMattingOptIsEdit(isEdit)
        mattingOptCallback.current = callback
    }

    const handleMattingOptSave = async () => {
        setMattingOptLoading(true)
        const resList = []
        for (let ref of mattingOptRefs.current) {
            const changed = await ref.saveHandle();
            console.log('changed', changed)
            if (changed) {
                const { blueMask, whiteMask, blendedImage, rect } = changed;
                let blendedImageUrl = null;
                if (blendedImage) {
                    blendedImageUrl = await Utils.uploadBase64Image(blendedImage)
                }
                resList.push({
                    binaryMask: whiteMask,
                    foregroundAlphaMask: blueMask,
                    foregroundMask: blendedImageUrl,
                    mattingRect: rect,
                })
            } else {
                setMattingOptLoading(false)
                message.error(imageType == IMAGE_TYPE.COMMODITY ? '请先在原图上框选要去除的内容！' : '请先在原图上标记出要替换的区域！', 5)
                return
            }
        }
        if (mattingOptCallback.current) {
            await mattingOptCallback.current(resList)
            mattingOptCallback.current = null
        }
        setMattingOptLoading(false)
        setMattingOptOpen(false)
    }

    // 仅初次打开弹出示例图
    const [popoverOpen, setPopoverOpen] = useState(false)
    useEffect(() => {
        if (mattingOptOpen && !localStorage.getItem('popoverOpen') && imageType == IMAGE_TYPE.GLASSES_TRYON) {
            localStorage.setItem('popoverOpen', true)
            setPopoverOpen(true)
        }
        if (mattingOptOpen && !localStorage.getItem('popoverOpen2') && imageType == IMAGE_TYPE.SIM_TRYON) {
            localStorage.setItem('popoverOpen2', true)
            setPopoverOpen(true)
        }
    }, [mattingOptOpen, imageType])

    const mattingOptOpenCancle = () => {
        setMattingOptOpen(false)
        if (glassesTryonKeyList.length > 0 && !glassesTryonKeyList[0]?.attr?.foregroundAlphaMask) {
            setGlassesTryonKeyList([])
        }
        if (simTryonKeyList.length > 0 && !simTryonKeyList[0]?.attr?.foregroundAlphaMask) {
            setSimTryonKeyList([])
        }
        if (imageType == IMAGE_TYPE.COMMODITY && !sceneKeyList[0]?.attr?.refMask && !mattingOptIsEdit) {
            if (mattingOptCallback.current) {
                mattingOptCallback.current([{
                    isManualSelection: true // 表示用户不需要去除背景主体
                }])
                mattingOptCallback.current = null
            }
        }
    }

    const PopoverContent = (
        <div className={styles.glassesSample}>
            {
                imageType == IMAGE_TYPE.GLASSES_TRYON ?
                    <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/glassesResourceSample.png" alt="" /> :
                    <div className={styles.simSample}>
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample1.png" alt="" />
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample2.png" alt="" />
                        <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/examples/sim_sample3.png" alt="" />
                    </div>
            }
            <p>{imageType == IMAGE_TYPE.GLASSES_TRYON ?
                '涂抹时，请完整覆盖模特的眼镜、耳朵和鼻梁；眼镜将佩戴在您标记的区域内' :
                '准确标记同版型的服装区域，效果会更好哦'}</p>
        </div>
    )


    // 是否是商品旧数据点了再次生成，此时要禁用侧边操作栏
    const CommidityOldDataRebuild = useMemo(() => {
        if (sceneKeyList.length == 0 || imageType != IMAGE_TYPE.COMMODITY) return false
        return sceneKeyList[0]?.attr?.commidityOldDataRebuild
    }, [sceneKeyList[0]?.attr?.commidityOldDataRebuild])

    const showCollapse = useMemo(() => {
        if (currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR || imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) return false
        return true
    }, [currentClothColorType, imageType])

    useEffect(() => {
        setOpen(false)
    }, [currentPoseFantasyMode])

    useEffect(() => {
        emojiInitRef.current = true
        setFlashModelUploaderBorder(false)
        setFlashModelRefBorder(false)
    }, [imageType])

    useEffect(() => {
        if (imageType != IMAGE_TYPE.MODEL) return
        if (emojiInitRef.current) {
            emojiInitRef.current = false
            return
        }
        if (emoji == MODEL_EXPRESSION.SRC) {
            setFlashModelRefBorder(false)
            setFlashModelUploaderBorder(true)
            const timer = setTimeout(() => setFlashModelUploaderBorder(false), 1200)
            return () => clearTimeout(timer)
        }
        if (emoji == MODEL_EXPRESSION.REF) {
            setFlashModelUploaderBorder(false)
            setFlashModelRefBorder(true)
            const timer = setTimeout(() => setFlashModelRefBorder(false), 1200)
            return () => clearTimeout(timer)
        }
    }, [emoji, imageType])

    return (
        <>
            <div className={styles.leftComp}>
                <div
                    className={`${styles.FixedTop} _none_scrollbar ${CommidityOldDataRebuild ? styles.FixedTopDisabled : ''}`}
                    style={{ paddingBottom: bottomRef.current?.clientHeight }}>
                    {CommidityOldDataRebuild && <p>历史数据再次生成禁止编辑</p>}
                    {isSmartDetailPage ? (
                        <SmartDetailPlaceholder
                            referenceCollapseItems={[{
                                key: RESOURCE_TYPE.TRYON_MODEL,
                                label: <div>参考图</div>,
                                children: <ReferSelectionTrigger
                                    {...optFactory(RESOURCE_TYPE.TRYON_MODEL, imageType)}
                                    multiple={false}
                                />,
                                showArrow: false,
                            }]}
                            referenceCollapseActiveKey={[RESOURCE_TYPE.TRYON_MODEL]}
                            onReferenceCollapseChange={() => { }}
                            referenceExpandIcon={expandIcon}
                            onOpenModelDrawer={() => handelOpenDrawer('preset', RESOURCE_TYPE.MODEL)}
                            onClearSelectedModel={() => setModelKeyList([])}
                            hasSelectedModel={modelKeyList.length > 0}
                            selectedModelUrl={modelKeyList?.[0]?.url}
                            detailImageList={smartDetailImageList}
                            onDetailImageListChange={setSmartDetailImageList}
                            productInfo={smartDetailProductInfo}
                            onProductInfoChange={setSmartDetailProductInfo}
                            mode={smartDetailMode}
                            onModeChange={setSmartDetailMode}
                            customItemList={smartDetailCustomItemList}
                            onCustomItemListChange={setSmartDetailCustomItemList}
                            clarity={smartDetailClarity}
                            onClarityChange={setSmartDetailClarity}
                            ratio={smartDetailRatio}
                            onRatioChange={setSmartDetailRatio}
                            platform={smartDetailPlatform}
                            onPlatformChange={setSmartDetailPlatform}
                            lang={smartDetailLang}
                            onLangChange={setSmartDetailLang}
                        />
                    ) : (
                        <>
                            <InputImageUploader flashModelBorder={flashModelUploaderBorder} />
                            {
                                showCollapse && <Collapse
                                    ghost
                                    expandIconPosition="end"
                                    items={items}
                                    defaultActiveKey={value}
                                    activeKey={value}
                                    expandIcon={expandIcon}
                                    onChange={handleCollapseChange}
                                />
                            }
                            {showImgToVideoParams &&
                                <ImgToVideoParams
                                    imageType={imageType}
                                    drawerOpen={open}
                                    resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO}
                                    onDrawerOpen={() => handelOpenDrawer("prompt", RESOURCE_TYPE.IMAGE_TO_VIDEO)}
                                    onDrawerClose={() => setOpen(false)} />}
                            {showResolution && <ResolutionSelectionWrap />}
                            {showGenerateMode && <GenerateMode imageType={imageType} />}
                            {showSkinRefine && <SkinRefine />}
                            {showRelight && <Relight imageType={imageType} />}
                            {showGenerateResolution && <SelectGenerateResolution />}
                            {showEmoji && <Emoji />}
                            {showModelHairstyle && <ModelHairstyle />}
                            {showColorSelection &&
                                <ColorSelection
                                    drawerOpen={open}
                                    resourceType={RESOURCE_TYPE.COMMODITY_COLOR}
                                    onDrawerOpen={() => handelOpenDrawer("collect", RESOURCE_TYPE.COMMODITY_COLOR)}
                                    onDrawerClose={() => setOpen(false)}
                                />}
                            {(showClothColorSelection && showCollapse) &&
                                <ColorSelection
                                    drawerOpen={open}
                                    resourceType={RESOURCE_TYPE.CLOTH_RECOLOR}
                                    onDrawerOpen={() => handelOpenDrawer("collect", RESOURCE_TYPE.CLOTH_RECOLOR)}
                                    onDrawerClose={() => setOpen(false)}
                                />}
                        </>
                    )}
                </div>
                <GenerateActionBar
                    showNumSelect={!isSmartDetailPage && showNumSelect}
                    generateNum={generateNum}
                    labelRender={labelRender}
                    setGenerateNum={setGenerateNum}
                    disabled={isSmartDetailPage ? smartDetailGenerateDisabled : generateDisabled(imageType, generateContext)}
                    isLoading={isLoading}
                    loading={loading}
                    handleGenerate={isSmartDetailPage && smartDetailMode === 'reference' ? handleSmartDetailContinue : handleGenerate}
                    costBean={isSmartDetailPage ? smartDetailCostBean : costBean}
                    bottomRef={bottomRef}
                    styles={styles}
                    showMemberIcon={isSmartDetailPage || imageType == IMAGE_TYPE.NECKLACE_TRYON}
                    buttonText={isSmartDetailPage && smartDetailMode === 'reference' ? '继续' : '生成'}
                    hideCostBean={isSmartDetailPage && smartDetailMode === 'reference'}
                />
            </div>
            <>
                <ReferSelectionDrawer
                    value={drawerValue}
                    open={open}
                    onOpenChange={setOpen}
                    defaultActiveKey={defaultActiveKey}
                    customDisabled={customDisabled}
                    resourceType={resourceType}
                    multiple={multiple}
                    imageType={imageType}
                    onUpload={handleUpload}
                    onChange={drawerOnChange}
                    onMattingOpt={handleMattingOpt}
                    hideRecommend={isSmartDetailPage && resourceType == RESOURCE_TYPE.TRYON_MODEL}
                />
                <UploadCustomMaterial
                    ref={uploadCustomMaterialRef}
                    handelOpenDrawer={handelOpenDrawer} />
            </>
            <PSAIModal
                title="生成确认"
                maxWidth={460}
                maskClosable={false}
                open={smartDetailConfirmOpen}
                okText="立即生成"
                cancelText="取消"
                okButtonProps={{
                    disabled: smartDetailNumLoading || !smartDetailImageCount,
                    loading: smartDetailNumLoading,
                }}
                onCancel={() => {
                    setSmartDetailConfirmOpen(false)
                }}
                onOk={() => {
                    setSmartDetailConfirmOpen(false)
                    handleGenerate()
                }}
            >
                {smartDetailNumLoading ? (
                    <div className={styles.SmartDetailConfirmAnalyzing}>正在分析参考图，请稍候...</div>
                ) : (
                    <div className={styles.SmartDetailConfirmDone}>
                        <div className={styles.SmartDetailConfirmTitle}>
                            {smartDetailConfirmType === 'analyzed' ? '参考图分析已完成' : ''}
                        </div>
                        <div className={styles.SmartDetailConfirmMain}>
                            将为您生成{smartDetailImageCount}张详情图，共计消耗 {smartDetailConfirmCostBean} 虹豆
                        </div>
                        <div className={styles.SmartDetailConfirmSub}>
                            {smartDetailConfirmType === 'detail'
                                ? `自定义模式共 ${smartDetailImageCount} 张 * ${smartDetailUnitPrice} 虹豆`
                                : `${smartDetailImageCount}张详情页图*${smartDetailUnitPrice}虹豆`}
                        </div>
                    </div>
                )}
            </PSAIModal>
            <PSAIModal
                title={
                    <>
                        {imageType == IMAGE_TYPE.GLASSES_TRYON ? '标记眼镜佩戴区域' :
                            imageType == IMAGE_TYPE.NECKLACE_TRYON ? '标记项链佩戴区域' :
                            imageType == IMAGE_TYPE.COMMODITY ? '标记要去除的内容' : '编辑重绘区域'}
                        {
                            imageType != IMAGE_TYPE.COMMODITY && <Popover
                                trigger="click"
                                onOpenChange={(open) => setPopoverOpen(open)}
                                open={popoverOpen}
                                placement="rightTop"
                                content={PopoverContent}>
                                <InfoCircleOutlined style={{ marginLeft: '10px', cursor: 'pointer' }} />
                            </Popover>
                        }

                    </>
                }
                maxWidth={imageType == IMAGE_TYPE.COMMODITY ? 600 : 1380}
                closable={false}
                maskClosable={false}
                open={mattingOptOpen}
                confirmLoading={mattingOptLoading}
                okText="保存修改"
                cancelText={imageType == IMAGE_TYPE.COMMODITY ? "暂不标记" : "放弃修改"}
                onCancel={mattingOptOpenCancle}
                onOk={handleMattingOptSave}
            >
                <div className={styles.MattingOptList}>
                    {
                        imageType == IMAGE_TYPE.GLASSES_TRYON || imageType == IMAGE_TYPE.NECKLACE_TRYON ? (
                            mattingOptGroups.map((item, index) => (
                                <div key={index + imageType} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                    <MattingOptGlasses
                                        ref={ref => mattingOptRefs.current[index] = ref}
                                        imageType={imageType}
                                        blueMask={item.foregroundAlphaMask}
                                        whiteMask={item.binaryMask}
                                        inputImage={item.inputImage}
                                    />
                                </div>
                            ))
                        ) : imageType == IMAGE_TYPE.COMMODITY ? (
                            mattingOptGroups.map((item, index) => (
                                <div key={index + IMAGE_TYPE.COMMODITY} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                    <MattingOptCommodityScene
                                        ref={ref => mattingOptRefs.current[index] = ref}
                                        imageType={imageType}
                                        blueMask={item.foregroundAlphaMask}
                                        whiteMask={item.binaryMask}
                                        inputImage={item.inputImage}
                                        rect={item.mattingRect}
                                    />
                                </div>
                            ))
                        ) : (
                            mattingOptGroups.map((item, index) => (
                                <div key={index + IMAGE_TYPE.SIM_TRYON} style={{ display: index == mattingOptIndex ? "block" : "none" }}>
                                    <MattingOptSimTryon
                                        ref={ref => mattingOptRefs.current[index] = ref}
                                        imageType={imageType}
                                        blueMask={item.foregroundAlphaMask}
                                        whiteMask={item.binaryMask}
                                        inputImage={item.inputImage}
                                        inputImageMultiSemanticId={item.semanticMaskId}
                                        inputImageMultiSemanticId2={item.semanticMaskId2}
                                        getMultiSemanticOutput={getMultiSemanticOutput}
                                        inputImageClothType={inputImageClothType}
                                    />
                                </div>
                            ))
                        )
                    }
                </div>
            </PSAIModal>
        </>
    )
}

export default LeftComp
